import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'

import { TextFormEntry, StateInput } from '../../components'

import { AddressShape } from './propTypes'

const isNullOrEmpty = (value) => (
    typeof value === "undefined" 
    || value === null
    || (typeof value === "string" && value === '')
);

const AddressesMatch = (address1, address2) => (
    (address1.AddressLine1 || '').toLowerCase() == (address2.AddressLine1 || '').toLowerCase()
    && (address1.AddressLine2 || '').toLowerCase() == (address2.AddressLine2 || '').toLowerCase()
    && (address1.AddressLine3 || '').toLowerCase() == (address2.AddressLine3 || '').toLowerCase()
    && (address1.City || '').toLowerCase() == (address2.City || '').toLowerCase()
    && (address1.State || '').toLowerCase() == (address2.State || '').toLowerCase()
    && (address1.PostalCode || '').toLowerCase() == (address2.PostalCode || '').toLowerCase()
    && address1.Phone == address2.Phone
    && (
        (typeof address2.IsResidential === "boolean" && address1.IsResidential == address2.IsResidential) ||
        (typeof address2.IsResidential === "string" && address1.IsResidential === (/true/i).test(address2.IsResidential)) ||
        (typeof address2.IsResidential === "undefined" && address1.IsResidential == address2.IsResidential)
    ));

const requiredFields = ["firstName", "lastName", "line1", "country", "city", "state", "postalCode"];

export class AddressEditor extends React.Component {
    constructor(props) {
        super(props);
        const newAddress = {
            FirstName: "",
            LastName: "",
            CompanyName: "",
            AddressLine1: "",
            AddressLine2: "",
            AddressType: props.addressType,
            City: "",
            CountryCode: "USA",
            CountryName: "",
            Id: "",
            Name: "",
            Phone: "",
            PostalCode: "",
            State: ""
        };
        this.state = {
            address: props.address || Object.assign({}, newAddress),
            submitAttempted: false,
            countriesStatesMap: props.countriesStatesMap,
            invalidFields: {},
            originalId: props.address && props.address.Id,
            validationRun: false,
            showValidationBypass: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.validateAddress = this.validateAddress.bind(this);
        this.handleOutsideFormSubmit = this.handleOutsideFormSubmit.bind(this);
        this.displayAddressConfirmationModal = this.displayAddressConfirmationModal.bind(this);
        this.displayAddressValidationErrors = this.displayAddressValidationErrors.bind(this);
        this.validateField = this.validateField.bind(this);
        this.isInvalid = this.isInvalid.bind(this);
        this.isRequired = this.isRequired.bind(this);
    }

    componentDidMount() {
        window.addEventListener('submit', this.handleOutsideFormSubmit);
    }

    componentWillUnmount() {
        window.removeEventListener('submit', this.handleOutsideFormSubmit);
    }

    isRequired(name) {
        return requiredFields.indexOf(name) > -1;
    }

    validateField(invalidFields, fieldName, value) {
        if (this.isInvalid(value, fieldName)) {
            invalidFields[fieldName] = true;
        } else {
            invalidFields[fieldName] = false;
        }
    }

    handleChange(event) {
        const address = Object.assign({}, this.state.address);
        const value = event.target.value;
        const name = event.target.name;
        switch (name) {
            case "name":
                address.Name = value;
                break;
            case "firstName":
                address.FirstName = value;
                break;
            case "lastName":
                address.LastName = value;
                break;
            case "companyName":
                address.CompanyName = value;
                break;
            case "line1":
                address.AddressLine1 = value;
                break;
            case "line2":
                address.AddressLine2 = value;
                break;
            case "city":
                address.City = value;
                break;
            case "state":
                address.State = value;
                break;
            case "postalCode":
                address.PostalCode = value;
                break;
            case "phone":
                address.Phone = value;
                break;
            default:
                if (typeof console.warn !== 'undefined')
                    console.warn(`Unknown value change with name '${name}' and value '${value}'`);
        }
        const invalidFields = Object.assign({}, this.state.invalidFields);
        this.validateField(invalidFields, name, value);
        this.setState({ address: address, invalidFields: invalidFields });
    }

    handleCountryChange(event) {
        const countryWithCode = this.props.countries.filter((c) => c.Code === event.target.value);
        if (countryWithCode.length > 0) {
            this.setState({
                address: Object.assign({},
                    this.state.address,
                    {
                        CountryCode: event.target.value,
                        CountryName: countryWithCode[0].Code
                    })
            });
        }
        event.preventDefault();
    }

    onSubmit(event) {
        event.preventDefault();
        if (!event.target.checkValidity()) {
            return;
        }
        const keys = this.state.invalidFields ? Object.keys(this.state.invalidFields) : [];
        const invalidFieldNames = keys.filter((key) => this.state.invalidFields[key]);
        let errorMessage = "";
        if (invalidFieldNames.length > 0) {
            errorMessage = `Please fix the following fields: ${invalidFieldNames.join(", ") + "."}`;
            this.setState({ errorMessage: errorMessage });
        } else {
            this.validateAddress(event, this.state.address);
            // this.props.onEditOk(this.state.address);
        }
    }

    getJsonFromParamaterizedString(str) {
        var hash = str.length;
        var query = str;
        var result = {};
        query.split("&").forEach(function (part) {
            if (!part) return;

            part = part.split("+").join(" "); // replace every + with space, regexp-free version
            var eq = part.indexOf("=");
            var key = eq > -1 ? part.substr(0, eq) : part;
            var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : "";

            if (key === 'AddressType') {
                val = parseInt(val, 10);
            }

            if (["IsErpAddress", "IsResidential"].find(name => name.toLowerCase() === key.toLowerCase())) {
                val = val.toLowerCase() === "true";
            }

            var from = key.indexOf("[");
            if (from == -1) result[decodeURIComponent(key)] = val;
            else {
                var to = key.indexOf("]", from);
                var index = decodeURIComponent(key.substring(from + 1, to));
                key = decodeURIComponent(key.substring(0, from));
                if (!result[key]) result[key] = [];
                if (!index) result[key].push(val);
                else result[key][index] = val;
            }
        });

        return result;
    }

    getDuplicateAddress(address) {
        var existingAddresses = this.props.existingAddresses;

        const matchedAddress = existingAddresses.find(a => AddressesMatch(a, address) && a.Id !== address.Id);
        return matchedAddress;
    }

    handleOutsideFormSubmit(event) {
        var self = this;
        if (event.target.id == "addressConfirmationForm") {
            event.preventDefault();
            var form = document.getElementById(event.target.id);
            var formData = new FormData(form);

            var selectedAddressId = formData.get('addressId');
            if (!selectedAddressId) {
                this.displayAddressValidationErrors('addressConfirmationModal', ['Please select an address to use.']);
                this.scrollToTop('addressConfirmationModal');
                return;
            }

            var objKey = 'addresses[' + selectedAddressId + ']';
            var addressParams = formData.get(objKey);

            if (!formData.has(objKey)) {
                this.displayAddressValidationErrors('addressConfirmationModal', ['The selected address could not be found. Please try again.']);
                this.scrollToTop('addressConfirmationModal');
                return;
            }

            var address = this.getJsonFromParamaterizedString(addressParams);
            if (address.Id === '00000000-0000-0000-0000-000000000000') {
                address.Id = '';
            }

            var duplicateAddress = this.getDuplicateAddress(address);
            if (duplicateAddress) {
                address = duplicateAddress;
            }

            this.setState({
                address: Object.assign({}, this.state.address, address)
            });

            window.$('#addressConfirmationModal').modal('hide');
            $('#addressConfirmationFormBody').html('');
            this.props.onEditOk(this.state.address);
        }
    }

    validateAddress(event, address) {
        var self = this;
        let serializedAddress = $.param(address);

        $('.addressEditor .loading-image').css('display', 'inline-block');

        $.ajax({
            type: "post",
            url: `/AddressValidation/ValidateAddress`,
            contenttype: "application/x-www-form-urlencoded",
            data: serializedAddress,
            success: function (response) {
                if (response.IsResolved) {
                    // no error
                    if (AddressesMatch(response.OriginalAddress, response.ResolvedAddress)) {
                        self.setState({
                            address: Object.assign({}, self.state.address, response.ResolvedAddress)
                        });
                        self.props.onEditOk(response.ResolvedAddress);
                    } else {
                        self.displayAddressConfirmationModal(response.OriginalAddress, response.ResolvedAddress);
                    }
                } else {
                    // error
                    self.setState({ showValidationBypass: true })
                    self.scrollToTopByClass('addAddressModal');
                }
            },
            error: function () {
                self.props.notifyError('Something went wrong. Please try again.');
                self.scrollToTopByClass('addAddressModal');
            },
            complete: function () {
                $('.addressEditor .loading-image').css('display', 'none');
            }
        });
    }

    displayAddressConfirmationModal(originalAddress, resolvedAddress) {
        if (!originalAddress || !resolvedAddress) {
            this.props.notifyError("Something went wrong. Please try again");
            return;
        }

        var addresses = [originalAddress, resolvedAddress];
        let addressHtml = '';

        for (var i = 0; i < addresses.length; i++) {
            let address = addresses[i],
                serializedAddress = $.param(address),
                title = i === 0 ? "You Entered" : "We Suggest",
                isStateValid = this.state.countriesStatesMap.USA.some(state => state.Code === address.State);

            addressHtml += `<input type="hidden" name="addresses[${i}]" value="${serializedAddress}"/>`;
            addressHtml += '<div class="row" style="margin-bottom:10px">';
            addressHtml += `<div class="col-sm-offset-1 col-sm-11"><h5><b>${title}:</b></h5></div>`;
            addressHtml += isStateValid
                ? `<div class="col-sm-1"><input type="radio" name="addressId" value="${i}"></div>`
                : `<div class="col-sm-1"><input type="radio" disabled='disabled' name="addressId" value="${i}" data-toggle="tooltip" title="Invalid State"></div>`;
            addressHtml += '<div class="col-sm-11">';
            addressHtml += `${address.AddressLine1}`;
            addressHtml += !isNullOrEmpty(address.AddressLine2) ? `<br/>${address.AddressLine2}` : '';
            addressHtml += `<br/>${address.City}, ${address.State} ${address.PostalCode}<br/>`;
            addressHtml += '</div>';
            addressHtml += isStateValid ? '' : '<div class="alert alert-danger" role="alert">Sorry, this is not an approved state, please update the address entered.</div>'
            addressHtml += '</div>';
        }

        $('form#addressConfirmationForm .addressConfirmationFormBody').html('');
        $('form#addressConfirmationForm .addressConfirmationFormBody').html(addressHtml);
        window.$('#addressConfirmationModal').modal('show');
    }

    displayAddressValidationErrors(id, errors) {
        if (errors && errors.length > 0) {
            let errorHtml = '';
            for (let key in errors) {
                errorHtml += `<li>${errors[key]}</li>`;
            }

            $('#' + id + ' .error-messages').html(errorHtml);
            $('#' + id + ' .error-messages').css('display', 'block');

            this.scrollToTop(id);
        }
    }

    scrollToTop(id) {
        window.$('#' + id).animate({ scrollTop: '0px' }, 300);
    }

    scrollToTopByClass(val) {
        window.$('.' + val).animate({ scrollTop: '0px' }, 300);
    }

    isInvalid(value, inputName) {
        if ((!value || value.length < 1) && this.isRequired(inputName)) {
            return true;
        }
        return false;
    }

    render() {
        const selectedAddress = this.state.address;
        const countryOptions = this.props.countries.map((country) =>
            <option key={country.Code} value={country.Code}>{country.Name}</option>
        );

        return (
            <form className="addressEditor" onSubmit={this.onSubmit} style={{ margin: 17 }}>
                {this.state.showValidationBypass &&
                    <div className="error-messages alert alert-danger">
                        <React.Fragment>
                            <p><strong>Address Validation Errors</strong></p>
                            <ul style={{ "listStyleType": "disc" }}>
                                <li>The address entered could not be validated. By choosing to continue, you could experience a delay in receiving your order - Thank you</li>
                            </ul>
                            <div align="center">
                                <button onClick={() => this.props.onEditOk(selectedAddress)} id="">Continue</button>
                            </div>
                        </React.Fragment>
                    </div>
                }
                {this.state.submitted && this.state.errorMessage &&
                    <div className="alert alert-danger" role="alert">
                        {this.state.errorMessage}
                    </div>
                }
                {this.props.isShippingAddress && <TextFormEntry name={'name'} value={selectedAddress.Name} label={" Shipping Address Nickname"} placeholder="Type in a name for this location. e.g. Main Office"
                    onChange={this.handleChange} isInvalid={this.isInvalid} isRequired={this.isRequired} forceShow={true}
                />}
                <TextFormEntry name={'firstName'} value={selectedAddress.FirstName} label={"First Name"}
                    onChange={this.handleChange} isInvalid={this.isInvalid} isRequired={this.isRequired}
                />
                <TextFormEntry name={'lastName'} value={selectedAddress.LastName} label={"Last Name"}
                    onChange={this.handleChange} isInvalid={this.isInvalid} isRequired={this.isRequired}
                />
                <TextFormEntry name={'companyName'} value={selectedAddress.CompanyName} label={"Company"}
                    onChange={this.handleChange} isInvalid={this.isInvalid} isRequired={this.isRequired}
                />
                <TextFormEntry name={'line1'} label={"Address Line 1"} value={selectedAddress.AddressLine1}
                    onChange={this.handleChange} isInvalid={this.isInvalid} isRequired={this.isRequired}
                    autocomplete={'address-line1'}
                />
                <TextFormEntry name={'line2'} label={"Address Line 2"} value={selectedAddress.AddressLine2}
                    onChange={this.handleChange} isInvalid={this.isInvalid} isRequired={this.isRequired}
                    autocomplete={'address-line'}
                />
                <div className={`${this.isInvalid("country") ? "error" : ""} input-container `}>
                    <label htmlFor="country" className="control-label">* Country:</label>
                    <div>
                        <select
                            value={selectedAddress.CountryCode}
                            onChange={this.handleCountryChange}
                            required
                            className="form-control"
                        >
                            {countryOptions}
                        </select>
                    </div>
                </div>
                <TextFormEntry name={'city'} value={selectedAddress.City} label={"City"}
                    onChange={this.handleChange} isInvalid={this.isInvalid} isRequired={this.isRequired}
                    autocomplete={'address-level2'}
                />
                <div className={`input-container ${(this.state.address.State === '') ? "error" : ""}`}>
                    <label htmlFor="state" className="control-label">* State:</label>
                    <div>
                        <StateInput
                            CountryCode={selectedAddress.CountryCode}
                            value={selectedAddress.State}
                            countriesStatesMap={this.state.countriesStatesMap}
                            onChange={this.handleChange}
                            isRequired={this.isRequired}
                        />
                    </div>
                </div>
                <TextFormEntry name='postalCode' value={selectedAddress.PostalCode} label="Postal Code"
                    onChange={this.handleChange} isInvalid={this.isInvalid} isRequired={this.isRequired}
                    autocomplete={'postal-code'}
                />
                <TextFormEntry type='tel' name={'phone'} value={selectedAddress.Phone} label={"Phone"}
                    onChange={this.handleChange} isInvalid={this.isInvalid} isRequired={this.isRequired}
                    autocomplete={'tel'}
                />
                <div className="form-group row">
                    <div className="col-xs-12">
                        <button type="submit" className="btn btn-primary" disabled="">Save/Select</button>
                        <button type="button" className="btn btn-link" style={{ marginLeft: 20 }} onClick={this.props.onEditCancel} value="Cancel">Cancel</button>
                    </div>
                </div>
            </form>
        );
    }
}

AddressEditor.propTypes = {
    addressType: PropTypes.number.isRequired,
    address: AddressShape.propTypes,
    countriesStatesMap: PropTypes.object.isRequired,
    countries: PropTypes.array.isRequired,
    onEditCancel: PropTypes.func.isRequired,
    onEditOk: PropTypes.func.isRequired,
    notifyError: PropTypes.func.isRequired
}

export default AddressEditor